// src/supabaseClient.js
// ─────────────────────────────────────────────────────
// STEP 1: Replace these two values with your own.
// Get them from: https://supabase.com/dashboard → your project → Settings → API
// ─────────────────────────────────────────────────────
import { createClient } from '@supabase/supabase-js'

const SUPABASE_URL = 'https://vukbnqpdkxpnbjxpyuxz.supabase.co'
const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InZ1a2JucXBka3hwbmJqeHB5dXh6Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzE2MjU0NTMsImV4cCI6MjA4NzIwMTQ1M30.OaNbmKj2JLbZFmIb4Pu8amKiRJT1O4TZpJveNzqjHHg'

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY)
